/**
 * The same page in the DevOps application, for a Console path it used to own.
 * Path, query and hash carry over unchanged, because the DevOps app mounts the
 * moved modules at the same paths (FNP-1633 to FNP-1635).
 */
export const devOpsUrlFor = (base: string, pathname: string, search: string, hash: string): string =>
    `${base.replace(/\/$/, '')}${pathname}${search}${hash}`;
